<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  created() {
      
    // 页面每次刷新加载时候都会去读取sessionStorage里面的vuex状态
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store")) //这里存的是可能经过mutions处理过的state值，是最新的,所以放在最后
        )
      )
    }
    // 在页面刷新之前把vuex中的信息存到sessionStoreage
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
    // const lang = JSON.parse(window.localStorage.getItem("lang"));
    // console.log(window.localStorage);
    // console.log(lang.prefLanguageValue);
    // // console.log(this.$i18n);
    // this.$i18n.locale = lang.prefLanguageValue;
    // console.log(this.$i18n);
  }
}
</script>


<style>
html,body{margin: 0px;padding: 0px;width: 100%;height: 100%;}
#app{width: 100%;height: 100%!important;margin: 0px;padding: 0px;position: absolute;

  /* background: url(./assets/background.jpg) no-repeat 100% 100%; */
/*background-size: cover;*/
/*background-repeat: repeat;*/
}
 /* @import './font/font.css'; */
 body{
	font-family: Arial, Helvetica, sans-serif;
 };
/* #nprogress .bar {
      background: rgb(96, 47, 231) !important;
} */
</style>

